import React from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from './Dashboard';
import CompanyPage from './CompanyPage';

// Resolves /:slug to either the user's own hub or a public company page.
// If the logged-in user is a reader and their username matches the slug, show Dashboard.
// Otherwise, treat the slug as a company link_id and show CompanyPage.
function SlugPage() {
  const { slug } = useParams();
  const userType = localStorage.getItem('userType');
  const username = localStorage.getItem('username');

  if (userType === 'user' && username === decodeURIComponent(slug)) {
    return <Dashboard />;
  }

  return <CompanyPage />;
}

export default SlugPage;
